<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ wardToEdit ? "Edit Ward" : "Add New Ward" }}</h3>
        <button type="button" class="close" @click="$emit('close-add-ward')">
          &times;
        </button>
      </div>

      <div class="modal-body">
        <div class="form-grid">
          <div class="form-group">
            <label>Ward Name</label>
            <input
              type="text"
              v-model="ward.name"
              placeholder="Enter ward name"
            />
          </div>

          <div class="form-group">
            <label>Ward Type</label>
            <select v-model="ward.type">
              <option value="" disabled>Select Ward Type</option>
              <option v-for="types in wtps" :value="types.id" :key="types.id">
                {{ types.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Capacity</label>
            <input type="number" v-model="ward.capacity" min="1" />
          </div>

          <div class="form-group">
            <label>Status</label>
            <select v-model="ward.status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button @click="$emit('close-add-ward')" class="btn btn-secondary">
          Cancel
        </button>
        <button @click="saveWard" class="btn btn-primary">
          {{ wardToEdit ? "Update Ward" : "Save Ward" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import showNotification from "../../../notification/notify";
export default {
  name: "WardModal",
  props: {
    wardToEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      wtps: [],
      ward: {
        name: "",
        type: "",
        capacity: 1,
        status: "active",
      },
    };
  },
  methods: {
    async saveWard() {
      const url = "inpatient/createWard";
      const body = {
        ward_name: this.ward.name,
        ward_type: this.ward.type,
        description: null,
        capacity: this.ward.capacity,
        status: this.ward.status,
      };
      try {
        await generalApiRequest(url, "POST", body, 1);
        showNotification("Added Successfully", "success");
        this.$emit("close-add-ward");
      } catch (error) {
        showNotification("Error adding Ward", "error");
      }
    },

    async getWardTypes() {
      const url = "inpatient/getWardTypes";
      const body = {};
      const tps = await generalApiRequest(url, "GET", body, 1);
      this.wtps = tps;
    },
    populateForm() {
      if (this.wardToEdit) {
        this.ward = {
          name: this.wardToEdit.ward_name,
          type: this.wardToEdit.ward_type,
          capacity: this.wardToEdit.capacity,
          status: this.wardToEdit.status,
        };
      }
    },
  },
  mounted() {
    this.getWardTypes();
    this.populateForm();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(34, 34, 34, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}

.modal-content {
  background: #fff;
  border-radius: 0.4rem;
  max-width: 70vw;
  width: 95%;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-header h3 {
  margin: 0;
}

.close {
  font-size: 1.4rem;
  background: #e51919;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

/* grid layout for form */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.form-group input,
.form-group select {
  padding: 0.45rem 0.6rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1.2rem;
}

.btn {
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}

.btn-primary {
  background: #2786f7;
  color: #fff;
}

.btn-secondary {
  background: #ccc;
}
</style>
